import { useQuery } from '@tanstack/react-query';
import http from "@/lib/http";

// The visitor's country does not change within a browser session, but the
// react-query cache below is in memory only, so every full page load (Topbar +
// Footer on every public page) re-called api.country.is. Keep the answer in
// sessionStorage so only the first page of a session pays for the request.
const STORAGE_KEY = 'hachion.countryIs';

const readCached = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const fetchCountry = async () => {
  const cached = readCached();
  if (cached?.country) return cached;
  const res = await http.get('https://api.country.is');
  if (res.status !== 200) throw new Error('Failed to fetch');
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(res.data));
  } catch {
    // storage unavailable (private mode etc.) - the in-memory query cache still dedupes
  }
  return res.data;
};

export const useTopBarApi = () => {
  const { data, error, isLoading } = useQuery({
    queryKey: ['userCountry'],
    queryFn: fetchCountry,
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    retry: 1,
  });

  const isIndia = data?.country?.toUpperCase() === 'IN';
  const countryCode = data?.country?.toUpperCase() || null;

  let whatsappNumber = '+1 (732) 485-2499';
  let whatsappLink = 'https://wa.me/17324852499';

  if (!error && data && isIndia) {
    whatsappNumber = '+91-949-032-3388';
    whatsappLink = 'https://wa.me/919490323388';
  }

  return {
    whatsappNumber,
    countryCode,
    whatsappLink,
    isLoading,
    error,
  };
};
